import {Component, Inject, OnInit} from '@angular/core';
import {SharedService} from '../../../../services/shared-service/shared.service';
import {UserService} from '../../../../services/users-service/user-service';
import {ErrorService} from '../../../../util/error_service/error.service';
import {MD_DIALOG_DATA, MdDialog, MdDialogRef} from "@angular/material";
import {Router} from "@angular/router";
import {ToastService} from "../../../../util/toast-service/toast.service";
import {AuthService} from "app/services/auth-service/auth-service.service";

@Component({
  selector: 'app-fund-agents',
  templateUrl: './fund-agents.component.html',
  styleUrls: ['./fund-agents.component.scss']
})
export class FundAgentsComponent implements OnInit {

  p = 1;


  public agentWithId = [];
  public newAgentWithId = [];

  public pageSize : any;
  public firstname = '';
  public lastname = '';
  public walletBalance: number = 0;
  public isBlocked: boolean;
  public agents: any;
  public isloading: boolean;
  public isLoadingAgents: boolean;
  public errorResponse: any;
  public fundedMessage : string;
  public searchInput : string;

  public range: any;
  public fromDate: Date;
  public toDate: Date;

  public searchText = '';
  pageTitle: string = 'Fund Agents';

  dialogRef: MdDialogRef<fundDialogComponent>;
  selectedOption: string;


  constructor( public dialog: MdDialog, private agentService: UserService, private router: Router,
               private authService: AuthService, private error: ErrorService, private sharedService: SharedService,
               private toast: ToastService) {
    this.sharedService.emitChange(this.pageTitle);
    this.isLoadingAgents = false;
    this.fundedMessage = '';
    this.searchInput = '';
    this.pageSize = '10';
    this.getAllAgents(true);
  }

  ngOnInit() {
  }


  ////////////////// get all agents info ////////////////////////////////////////////////////
  getAllAgents = (newLoad = false) => {
    if (newLoad) {
      this.isLoadingAgents = true;
    } else {
      this.isLoadingAgents = false;
    }
    this.agentService.getAgents().subscribe(
      response => {
        // console.log("************ Agents list ****************");
        // console.log(response.data);
        this.agents = response.data.filter(agent => agent.deleted !== 1 && agent.blocked !== 1);
        this.isLoadingAgents = false;
        this.getAgentWithSortedId();
      },
      err => {
        // console.log(err);
        this.errorResponse = this.error.errorHandlerWithText(this.getAllAgents, err);
        this.isLoadingAgents = false;
        // console.log(this.errorResponse);

      }
    )
  }


  // Sort data ////////////////////
  getAgentWithSortedId() {
    this.agentWithId = [];
    this.agents.sort(function(a, b) {
      return - ( a.id - b.id  ||  a.name.localeCompare(b.name) );
    });
    let i = 0
    for (const agent of this.agents) {
      const sortedAgents: any = {id: 0, data: {}};
      i += 1;
      sortedAgents.id = i;
      sortedAgents.data = agent;
      this.agentWithId.push(sortedAgents);
    }
    // console.log(this.agentWithId);
    this.isLoadingAgents = false;
  }


  fundDialog(userData:any) {
    // console.log("userdata",userData);

    let dialogRef = this.dialog.open(fundDialogComponent,{
      height: '280px',
      width: '400px',
      data: {
        userId: userData.id,
        walletBalance: userData.walletBalance,
        firstName: userData.firstName,
        lastName: userData.lastName
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result == 'close'){
        return false;
      }
      const message = result.firstname+'\'s wallet was credited with ₦'+result.amount+' successfully';
      this.fundedMessage = message;
      this.toast.showSuccess(message, 'Wallet Credited');
      this.getAllAgents(false);
    });

    if(this.fundedMessage != ''){
      // console.log('not empty');
    }
  }
}


@Component({
  selector: 'dialog-result',
  styles: [ '.user-details { margin-bottom: 5px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: center;}',
    '.user-details span{ color:#444; text-transform:uppercase; text-overflow:ellipsis}',
    '.wallet { font-weight: normal; padding:2px 5px; border-radius:5px;text-align: center;} background-color:#ededed; display: inline-block;} '],
  templateUrl: 'dialog-result.html',
})
export class fundDialogComponent {

  public firstName : string;
  public lastName: string;
  public userId : number;
  public walletBalance : number;
  public amount : number;
  public fundText : string;
  public isFunding : boolean;


  constructor(
    public dialogRef: MdDialogRef<fundDialogComponent>,private agentService: UserService, private error: ErrorService,
    @Inject(MD_DIALOG_DATA) public data: any) {
    this.userId = this.data.userId;
    this.firstName = this.data.firstName;
    this.lastName = this.data.lastName;
    this.walletBalance = this.data.walletBalance;
    this.amount = null;

    this.fundText = 'Fund Wallet';
    this.isFunding = false;
  }




  fundAgent = () => {

    const fundMessage = {funded: false, amount: 0, firstname : ''}
    this.fundText = 'Funding....';
    this.isFunding = true;

    this.agentService.fundWallet(this.userId, this.amount).subscribe(
      data => {
        fundMessage.funded = true;
        fundMessage.amount = this.amount;
        fundMessage.firstname = this.firstName;
        this.fundText = 'Fund Wallet';
        this.isFunding = false;

        this.dialogRef.close(fundMessage);
      },
      err => {
        // console.log(err);
        const msg = this.error.errorHandlerWithText(this.fundAgent, err);
      }
    )
  }


}



// WEBPACK FOOTER //
// ./src/app/Dashboard/DashboardPages/funding/fund-agents/fund-agents.component.ts